export default __webpack_public_path__ + "static/media/travel.cc729dfd.png";